<ng-container *ngIf="dataResolved$ | async; else loading">
    <div
        class="wrapper"
        *ngIf="NewSwimLanes as swimLanes"
        cdkDropListGroup
    >
        <ng-container *ngFor="let lane of swimLanes; let i = index; trackBy: TrackLanes">
            <button
                *ngIf="lane.Headline === 'Erledigt' && inlineCompleteToggleButton"
                (click)="toggleCompleted()"
                class="collapsedButton"
                [ngClass]="{ 'left-position': showCompleted }"
            >
                <fa-icon
                    [icon]="!showCompleted ? 'chevron-left' : 'chevron-right'"
                    [matTooltip]="!showCompleted ? 'Erledigt ausklappen' : 'Erledigt einklappen'"
                    class="toggle-icon"
                ></fa-icon>

            </button>
            <div
                class="swimLane"
                *ngIf="showCompleted || lane.Headline !== 'Erledigt'"
            >
                <h4>{{ lane.Headline }}</h4>
                <button
                    style="width: 100%"
                    (click)="OpenAddTaskDialog()"
                    mat-raised-button
                    color="primary"
                    *ngIf="ShowNewButton && i === 0"
                >
                    <div style="width: 100%; display: flex">
                        neue Aufgabe <fa-icon icon="plus" style="margin-left: auto"></fa-icon>
                    </div>
                </button>
                <div
                    class="inner-wrapper"
                    cdkDropList
                    cdkDropListSortingDisabled
                    [cdkDropListDisabled]="DisableDragNDrop$ | async"
                    [cdkDropListData]="lane.Id"
                    (cdkDropListDropped)="Drop($event)"
                >
                    <p class="no-items">keine Aufgaben vorhanden</p>
                    <app-event-card
                        *ngFor="let task of lane.events$ | async"
                        [id]="task.Id"
                        [cdkDragData]="task.Id"
                        cdkDrag
                        (FileClicked)="FileClicked.emit($event)"
                        style="margin-top: 1rem; display: block;"
                        [Event]="task"
                        [folderIdForSelectDocumentsDialogInDetailTask]="folderIdForSelectDocumentsDialogInDetailTask"
                    ></app-event-card>
                    <button app-button (click)="nextPage(lane.page$, 5)" *ngIf="(lane.isLastPage$ | async) === false">mehr laden</button>
                </div>
            </div>
        </ng-container>

    </div>
</ng-container>
<ng-template #loading><app-loading></app-loading></ng-template>
